import {Form, Row, Col, Card, Select, notification, InputNumber, Input, Button} from 'antd';
import React, {useEffect, useState} from "react";
import jsonfile from './chartofaccount.json'
import {CisUI} from '../../../../../util/CISUI'
import 'react-smart-data-table/dist/react-smart-data-table.css'
import Config from "../../../../../util/config";
import axios from "../../../../../util/Api";
import {useHistory} from "react-router-dom";
import $ from "jquery";
import SelectData from "../../../../../util/selectdata";
import IntlMessages from "../../../../../util/IntlMessages";

const { Option } = Select;

const EditAdminGL = (props) => {

    const formRef = React.createRef();
    const [loading, setLoading] = useState(false);

    const AccountsLevel = [
        {id: 1, name: "All"},
        {id: 3, name: "HQ"},
        {id: 4, name: "Area"},
        {id: 5, name: "District"},
        {id: 6, name: "Local"}
    ];

    const AllAccounts = SelectData("accounts/allaccountsbylevelv2");
    const AccountTypes = SelectData("accounts/accounttype");
    const Status = SelectData("getstatus");

    const [accounts, setAccounts] = useState([]);
    const [type, setAccountType] = useState([]);
    const [status, setStatus] = useState([]);

    const [form] = Form.useForm();

    const history = useHistory();

    const handleChange=(e)=> {
        // setState({
        //     [e.target.id]: e.target.value
        // })
        console.log(e.target.value);
    }

    const userID = props.match.params.id;
    console.log("Userid : "+props.match.params.id);
    let isEdit = 0;
    if(userID > 0) {
        isEdit = 1;
    }
    // let Title = jsonfile.addtitle;
    // let endpoint = jsonfile.urls.add;
    // let redirectto = "../"+jsonfile.urls.list;
    // let userData = [];

    // if(isEdit === 1 ) {
    //     userData = RemoteJson(jsonfile.urls.view+"/"+userID);
    //
    let Title = jsonfile.edittitle;
    let endpoint = "accounts/accountedit"+"/"+userID;
    let redirectto = "../../accounts/hqgllist";

    useEffect(()=>{
        setLoading(true);
        if (!AllAccounts || AllAccounts.length === 0) return;
        if (!AccountTypes || AccountTypes.length === 0) return;
        // if (!Status || Status.length === 0) return;

        axios.get(Config.apiserver + jsonfile.urls.view + "/" + userID)
        .then(res => {
            if(res.data.status === 1) {
                console.log(res.data);
                console.log("type", AccountTypes);
                let data = res?.data?.data;
                if(data?.act_level){
                    setAccounts(AllAccounts[data?.act_level]);
                }
                setAccountType(AccountTypes);
                // setStatus(Status);
                form.setFieldsValue({
                    'act_level': res?.data?.data?.act_level,
                    'parent_id': res?.data?.data?.parent_id,
                    'act_type': res?.data?.data?.act_type,
                    'account_number': res?.data?.data?.account_number,
                    'account_name': res?.data?.data?.account_name,
                    'description': res?.data?.data?.description,
                    'status': res?.data?.data?.status,
                })

            }
            else {
                notification.warning({
                    message: 'Alert',
                    type : "warning",
                    description: res.data.msg
                });
            }
            setLoading(false);
        })
        .catch(errors => {
            console.log(errors);
        })
    }, [AllAccounts, AccountTypes]);

    const onFinish = (values) => {
        //setLoading({loading:true})
        console.log("Input Endpoint : "+endpoint);
        console.log("Input Data : "+values);
        // return;
        // let msg = "Sorry! request not processed, please try again";

        axios.post(Config.apiserver + endpoint, values)
            .then(res => {
                console.log(res)
                if(res.data.status === 1) {
                    notification.warning({
                        message: 'Alert',
                        type : "warning",
                        description: res.data.msg
                    });
                    if(values.act_level === 3) {
                        history.push("../../accounts/hqgllist");
                    }
                    else if(values.act_level === 4) {
                        history.push("../../accounts/areagllist");
                    }
                    else if(values.act_level === 5) {
                        history.push("../../accounts/districtgllist");
                    }
                    else if(values.act_level === 6) {
                        history.push("../../accounts/localgllist");
                    }
                }
                else {
                    notification.warning({
                        message: 'Alert',
                        type : "warning",
                        description: res.data.msg
                    });
                }
                setLoading({loading:false});
            })
            .catch(errors => {
                console.log(errors);
                // msg = (errors);
                setLoading({loading:false});
                //setResponse([]);
            });
    };

    // $("#input_parent_account_number").change(function(){
    //     const vl = document.getElementById("#input_parent_account_number").value;
    //     console.log(vl);
    // });

    $('#input_parent_account_number').unbind('keyup');
    $('#input_parent_account_number').bind('keyup', function (e) {
        const parent = this.value;
        const level = formRef.current.getFieldValue("act_level");
        if(level === null) {
            notification.warning({
                message: 'Alert',
                type : "warning",
                description: "Please select a Account Level"
            });
        }

        if(parent.length === 5) {
            CisUI().LoadingOn();
        }

    });

    const onLevelChange = value => {
        setAccounts(AllAccounts[value]);
    };

    // $("#input_parent_account_number").keyup(function () {
    //     console.log(this.value);
    // });

    //console.log("UserData : "+userData);

    // const ParentAccount = (
    //     userData == "" && isEdit == 1 ? <CircularProgress/> : (
    //         <>
    //
    //             </> )
    // )

    return (
        <Card title={Title}
            extra={CisUI().addAction('../../'+jsonfile.urls.list)}
        >

            {
                !loading ?

            <Form
                form={form}
                {...CisUI().formItemLayout}
                name="input"
                ref={formRef}
                className="ant-advanced-search-form"
                onFinish={onFinish}
            >
                <Row gutter={24}>
                    {
                        CisUI().getUserInfo('area') >= 26 ? <></> :
                        <Col lg={12} md={12} sm={12} xs={24} >
                            <div className="gx-form-row0">
                                <Form.Item
                                    name="act_level"
                                    label="Add To"
                                    // initialValue={userData?.act_level}
                                    // defaultvalue={userData?.act_level}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Select a level"
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Select a level"
                                        optionFilterProp="children"
                                        onChange={onLevelChange}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {
                                            AccountsLevel.map((items, index) =>
                                                <Option key={++index} value={items.id} >{items.name}</Option>
                                            )
                                        }
                                    </Select>
                                </Form.Item>

                            </div>
                        </Col>
                    }

                    <Col lg={12} md={12} sm={12} xs={24} id="parents" >
                        <div className="gx-form-row0">
                            <Form.Item
                                name="parent_id"
                                label="Parent Account Number (If it is subsidiary account)"
                                // initialValue={userData.parent_id}
                                rules={[
                                    {
                                        required: false,
                                        message: "Select a Parent Account"
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select a Parent Account"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {
                                        CisUI().getUserInfo('com_id') > 0 ?
                                            AllAccounts.map((items, index) =>
                                                <Option key={++index} value={items.id} >{items.name}</Option>
                                            )
                                            :
                                            accounts.map((items, index) =>
                                                <Option key={++index} value={items.id} >{items.name}</Option>
                                            )
                                    }
                                </Select>
                            </Form.Item>
                        </div>
                    </Col>

                    <Col lg={12} md={12} sm={12} xs={24} >
                        <div className="gx-form-row0">
                            <Form.Item
                                name="act_type"
                                label="Account Type"
                                // initialValue={userData?.act_level}
                                // defaultvalue={userData?.act_level}
                                rules={[
                                    {
                                        required: true,
                                        message: "Select a level"
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select a level"
                                    optionFilterProp="children"
                                    // onChange={onLevelChange}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {
                                        type?.map((items, index) =>
                                            <Option key={++index} value={items.id} >{items.name}</Option>
                                        )
                                    }
                                </Select>
                            </Form.Item>
                        </div>
                    </Col>

                    <Col lg={12} md={12} sm={12} xs={24} >
                        <div className="gx-form-row0">
                            <Form.Item
                                name="account_number"
                                label="Account Number"
                                rules={[
                                    {
                                        required: true,
                                        message: "Account Number is required"
                                    },
                                ]}
                            >
                                <InputNumber className="gx-w-100" />
                            </Form.Item>
                        </div>
                    </Col>

                    <Col lg={12} md={12} sm={12} xs={24} >
                        <div className="gx-form-row0">
                            <Form.Item
                                name="account_name"
                                label="Account Name"
                                rules={[
                                    {
                                        required: true,
                                        message: "Account Name is required"
                                    },
                                ]}
                            >
                                <Input placeholder="Account Name" />
                            </Form.Item>
                        </div>
                    </Col>

                    <Col lg={12} md={12} sm={12} xs={24} >
                    <div className="gx-form-row0">
                        <Form.Item
                            name="description"
                            label="Description"
                            rules={[
                                {
                                    required: true,
                                    message: "Description is required"
                                },
                            ]}
                        >
                            <Input placeholder="Description" />
                        </Form.Item>
                    </div>
                </Col>
                    <Col lg={12} md={12} sm={12} xs={24} >
                        <div className="gx-form-row0">
                            <Form.Item
                                name="status"
                                label="Status"
                                // initialValue={userData?.act_level}
                                // defaultvalue={userData?.act_level}
                                rules={[
                                    {
                                        required: true,
                                        message: "Select a status"
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select a level"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {
                                        Status?.map((items, index) =>
                                            <Option key={++index} value={items.id} >{items.name}</Option>
                                        )
                                    }
                                </Select>
                            </Form.Item>

                        </div>
                    </Col>

                </Row>
                <Row gutter={24} className="form-card-footer">
                    <Col lg={24} md={24} sm={12} xs={24} style={{textAlign: 'center'}}>
                        <Button type="primary" htmlType="submit">
                            <IntlMessages id={`Submit`} />
                        </Button>
                        {/*<Button type="info" onClick={() => history.goBack()} htmlType="back"><IntlMessages id={"Cancel"} /></Button>*/}
                        <Button type="info" onClick={() => history.push(redirectto)}><IntlMessages id={"Cancel"} /></Button>
                    </Col>
                </Row>

                {/*{InputFields(jsonfile.input,userData,isEdit)}*/}

            </Form>
                    :
                    ""
            }

        </Card>
    );
};

export default EditAdminGL;